import * as Yup from 'yup';
import { DOMAIN_REG_EX, EMAIL_REG_EX } from '../utils/regex';
import {
  INSTANCE_PHONE_REG_EX,
  INSTANCE_PHONE_MIN_LENGTH,
} from '../utils/instanceConstant';
export const getOrgProfileInitialValues = (organization) => {
  return {
    name: organization && organization.name ? organization.name : '',
    industrySectorTypeId:
      organization && organization.industrySectorTypeId
        ? organization && organization.industrySectorTypeId
        : '',
    phone: organization && organization.phone ? organization.phone : '',
    domain: organization && organization.domain ? organization.domain : '',
    email: organization && organization.email ? organization.email : '',

    country: organization && organization.country ? organization.country : '',
    streetAddress:
      organization && organization.streetAddress
        ? organization.streetAddress
        : '',
    streetAddress2:
      organization && organization.streetAddress2
        ? organization && organization.streetAddress2
        : '',
    citySuburb:
      organization && organization.citySuburb ? organization.citySuburb : '',
    stateId: organization && organization.stateId ? organization.stateId : '',
    postcode:
      organization && organization.postcode ? organization.postcode : '',
    postalStreetAddress:
      organization && organization.postalStreetAddress
        ? organization.postalStreetAddress
        : '',
    postalStreetAddress2:
      organization && organization.postalStreetAddress2
        ? organization.postalStreetAddress2
        : '',
    postalCitySuburb:
      organization && organization.postalCitySuburb
        ? organization.postalCitySuburb
        : '',
    postalStateId:
      organization && organization.postalStateId
        ? organization.postalStateId
        : '',
    postalPostcode:
      organization && organization.postalPostcode
        ? organization.postalPostcode
        : '',
  };
};

export const profileValidationSchema = (t) =>
  Yup.object().shape({
    name: Yup.string().required(
      t('formulary.validation.organisation_name_required')
    ),
    phone: Yup.string()
      .required(t('formulary.validation.phone_number_required'))
      .matches(
        INSTANCE_PHONE_REG_EX,
        t('formulary.validation.please_enter_the_valid_format')
      )
      .min(
        INSTANCE_PHONE_MIN_LENGTH,
        t('formulary.validation.must_be_a_minimum_of_digits', {
          count: INSTANCE_PHONE_MIN_LENGTH,
        })
      ),
    domain: Yup.string()
      .required(t('formulary.validation.web_domain_required'))
      .matches(
        DOMAIN_REG_EX,
        t('formulary.validation.please_enter_the_valid_format')
      ),
    email: Yup.string()
      .required(t('formulary.validation.email_required'))
      .matches(
        EMAIL_REG_EX,
        t('formulary.validation.please_enter_the_valid_format')
      ),

    country: Yup.string().required(t('formulary.validation.country_required')),
    streetAddress: Yup.string().required(
      t('formulary.validation.street_address_required')
    ),
    citySuburb: Yup.string().required(
      t('formulary.validation.city_suburb_required')
    ),
    stateId: Yup.string().required(t('formulary.validation.state_required')),
    postcode: Yup.string().required(
      t('formulary.validation.postal_code_required')
    ),
  });

export const profileValidationSchemaWithDifferentPostalAddress = (t) =>
  Yup.object().shape({
    name: Yup.string().required(
      t('formulary.validation.organisation_name_required')
    ),
    phone: Yup.string()
      .required(t('formulary.validation.phone_number_required'))
      .matches(
        INSTANCE_PHONE_REG_EX,
        t('formulary.validation.please_enter_the_valid_format')
      )
      .min(
        INSTANCE_PHONE_MIN_LENGTH,
        t('formulary.validation.must_be_a_minimum_of_digits', {
          count: INSTANCE_PHONE_MIN_LENGTH,
        })
      ),
    domain: Yup.string()
      .required(t('formulary.validation.web_domain_required'))
      .matches(
        DOMAIN_REG_EX,
        t('formulary.validation.please_enter_the_valid_format')
      ),
    email: Yup.string()
      .required(t('formulary.validation.email_required'))
      .matches(
        EMAIL_REG_EX,
        t('formulary.validation.please_enter_the_valid_format')
      ),
    country: Yup.string().required(t('formulary.validation.country_required')),
    streetAddress: Yup.string().required(
      t('formulary.validation.street_address_required')
    ),
    citySuburb: Yup.string().required(
      t('formulary.validation.city_suburb_required')
    ),
    stateId: Yup.string().required(t('formulary.validation.state_required')),
    postcode: Yup.string().required(
      t('formulary.validation.postal_code_required')
    ),
    postalStreetAddress: Yup.string()
      .required(t('formulary.validation.postal_address_required'))
      .nullable(),
    postalCitySuburb: Yup.string()
      .required(t('formulary.validation.postal_city_suburb_required'))
      .nullable(),
    postalStateId: Yup.string()
      .required(t('formulary.validation.postal_state_required'))
      .nullable(),
    postalPostcode: Yup.string()
      .required(t('formulary.validation.postal_postcode_required'))
      .nullable(),
  });
